(ns frontend.view.modals.dynamic.view
  (:require
   [frontend.view.modals.dynamic.events :as events]
   [ui.components.modal.view :as modal]))

(defonce modal-key :dynamic-modal)

(defn- errors->tooltip
  "Render the validator result as a tooltip hiccup:
   - string  -> single-line message
   - coll    -> bulleted list of items
   - other   -> nil (no tooltip).

   The validator is responsible for any truncation/localization of the
   list items since this view does not know the user's language."
  [errors]
  (cond
    (string? errors)
    [:span errors]

    (and (coll? errors) (seq errors))
    [:ul
     {:class "list-disc pl-4 m-0"}
     (->> errors
          (map-indexed (fn [idx err]
                         ^{:key (str "dynamic-modal-error-" idx)}
                         [:li (str err)]))
          doall)]))

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [on-show]} props]
    (when (fn? on-show)
      (on-show state))
    (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
      (let [{:keys [title render-fn show-button? button-text custom-class
                    on-submit! on-close! on-before-close! on-show
                    size backdrop keyboard custom-validator-fn]}
            props
            close! (fn []
                     (when (fn? on-close!)
                       (on-close!))
                     (close-modal!))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         (fn [_]
                           (if (fn? on-before-close!)
                             (on-before-close! close!)
                             (close!))) ;; sm/small or lg/large
          :backdrop      (or backdrop "static")
          :size          size
          :close-button? true}
         (if (fn? title)
           (title)
           title)
         [:<>
          (render-fn state close-modal!)]
         (when show-button?
           (let [errors  (if (fn? custom-validator-fn)
                           (custom-validator-fn state)
                           (events/form-not-ready? state))
                 tooltip (errors->tooltip errors)]
             [modal/right-single-button
              nil
              (boolean tooltip)
              (fn [_]
                (on-submit! state)
                (close-modal!))
              button-text
              nil
              tooltip]))]))))
